module.exports = "/images/th.svg?5e861063d7115f6552372661c174dce4";